


  $('.slide-list').slick({
  arrows: true,
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1
});




$(document).off("click","#header_wish_list");
$(document).on("click","#header_wish_list",function(e) { 
    var loo_count = $(".loo-count").html();
    $("#wish_list_count").html(loo_count);  
    $(".loo-count").click();  
});


$( document ).ready(function() {
  var loo_count = $(".loo-count").html();
  $("#wish_list_count").html(loo_count);  
  $(".loo-lists-bar").hide();
  
$('.home-tabs-slider .tab-slider-main-1').slick({
  dots: false,
   arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
})
});



$( document ).ready(function() {
$('.reviewBox').slick({
  dots: false,
   arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2.5,
  slidesToScroll: 1,
   responsive: [

        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
})
});




$( document ).ready(function() {
$('.home-tabs-slider .tab-slider-main').slick({
  dots: false,
   arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
});

$('.home-tabs-slider .tab-slider-main-1').slick({
  dots: false,
   arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
})

/* collection tag filter select box js start */
var $browseBy = $('#BrowseBy');
$(function() {
  $browseBy.bind('change', function() {
    location.href = $browseBy.val();
  });
});
var $browseByMobile = $('#BrowseByMobile');
$(function() {
  $browseByMobile.bind('change', function() {
    location.href = $browseByMobile.val();
  });
});  
/* collection tag filter select box js end */  
});







